import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

export const ACTION_FETCH_COUNTRIES = 'ACTION_FETCH_COUNTRIES';
export const REQUEST_FETCH_COUNTRY = 'REQUEST_FETCH_COUNTRY';
export const REQUEST_FETCH_COUNTRY_SUCCESS = 'REQUEST_FETCH_COUNTRY_SUCCESS';
export const REQUEST_FETCH_COUNTRY_FAILURE = 'REQUEST_FETCH_COUNTRY_FAILURE';

const defaultState = {
  // get country
  countries: [],
  isFetchingCountry: false,
  isFetchCountrySuccess: false,
  isFetchCountryFailure: false,
};

const reducer = createReducer(defaultState, {
  // get country
  [REQUEST_FETCH_COUNTRY]: (state, _action) => ({
    ...state,
    isFetchingCountry: true,
    isFetchCountrySuccess: false,
    isFetchCountryFailure: false,
  }),
  [REQUEST_FETCH_COUNTRY_SUCCESS]: (state, action) => ({
    ...state,
    countries: [{ id: '', iso: '', name: 'All Country' }, ...(action.payload?.data?.items || [])],
    isFetchingCountry: false,
    isFetchCountrySuccess: true,
    isFetchCountryFailure: false,
  }),
  [REQUEST_FETCH_COUNTRY_FAILURE]: (state) => ({
    ...state,
    isFetchingCountry: false,
    isFetchCountrySuccess: false,
    isFetchCountryFailure: true,
  }),
});

export default reducer;
export const namespace = 'country';

export const actionFetchCountry = (payload) => ({
  type: ACTION_FETCH_COUNTRIES,
  payload,
});

export const fetchCountryAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/countries',
    actionTypes: [
      REQUEST_FETCH_COUNTRY,
      REQUEST_FETCH_COUNTRY_SUCCESS,
      REQUEST_FETCH_COUNTRY_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};
